var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"tag":"div","rules":_vm.rules,"name":_vm.name,"vid":_vm.vid,"mode":_vm.customMode},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('div',{ref:"textarea"},[_c('textarea-autosize',{class:[
        _vm.inputClass,
        {
          'is-invalid': errors.length,
        },
      ],attrs:{"min-height":_vm.calcMinHeight,"max-height":_vm.calcMaxHeight,"rows":_vm.rows,"disabled":_vm.disabled},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1),_c('b-tooltip',{attrs:{"target":() => _vm.$refs['textarea'],"title":errors.length ? errors[0] : null,"variant":"danger","noninteractive":"","placement":"top","boundary":"window"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }